export default {
  tcsoc: '',
  tnocl: '',
  tclang: '',
  tnom: '',
  tadr1l: '',
  tadr2l: '',
  tadr3l: '',
  tcpostl: '',
  tvillel: '',
  tcpaysl: '',
  tcprovl: '',
  tadr1f: '',
  tadr2f: '',
  tadr3f: '',
  tcpostf: '',
  tvillef: '',
  tcpaysf: '',
  tcprovf: '',
  ttel: '',
  tcdiv: '',
  tcsdiv: '',
  tccom: '',
  tcdev: '',
  tsiret: '',
  ttvacee: '',
  tweb: '',
  tnomc: '',
  tpnomc: '',
  tmailc: '',

  pmdp: '',
  pmdp_confirm: '',
};